import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EVIDENCE_STORE_KEY, IEvidenceState } from './data-access.state';

const state = createFeatureSelector<IEvidenceState>(EVIDENCE_STORE_KEY);

export const evidenceSelector = createSelector(state, (state1: IEvidenceState) => state1.evidenceAndPreview);
export const previewSelector = createSelector(state, (state1: IEvidenceState) => state1.preview);
export const isLoading = createSelector(state, (state1: IEvidenceState) => state1.isLoading);
export const evidenceUidSelector = createSelector(state, (state1: IEvidenceState) => state1.evidenceUid);
export const evidenceLocationSelector = createSelector(state, (state1: IEvidenceState) => state1.location);
export const evidenceIsLocationLoadingSelector = createSelector(state, (state1: IEvidenceState) => state1.isLocationLoading);
export const actionResult = createSelector(state, (state1: IEvidenceState) => state1.actionResult);
export const evidenceLinks = createSelector(state, (state1: IEvidenceState) => state1.links);
export const isLockCodeNeeded = createSelector(state, (state1: IEvidenceState) => state1.isLockCodeRequired);
